export default __webpack_public_path__ + "static/media/prologue-couch-negative.edf562c5.png";